import { solicitar } from '../identidad/cliente-identidad.js'

export type TipoActor = 'COORDINADOR_ASESORES' | 'ASESOR' | 'ESTUDIANTE' | 'TITULAR'
export interface Actor {
  id: string
  estudianteId: string | null
  nombres: string
  apellidos: string
  correo: string
  celular: string | null
  estado: 'ACTIVO' | 'INACTIVO'
  version: number
  programaId: string | null
  programaNombre: string | null
  institucionId: string | null
  institucionNombre: string | null
  asesorId: string | null
  asesorNombre: string | null
  asesorAsignacionVersion: number | null
  titularId: string | null
  titularNombre: string | null
  titularAsignacionVersion: number | null
  estudiantesAsignados: number
}
interface Pagina {
  datos: Actor[]
  siguienteCursor: string | null
}
const rutas: Record<TipoActor, string> = {
  COORDINADOR_ASESORES: 'coordinadores-asesores',
  ASESOR: 'asesores',
  ESTUDIANTE: 'estudiantes',
  TITULAR: 'titulares',
}
export const listarActores = (tipo: TipoActor): Promise<Pagina> =>
  solicitar(`/api/v1/${rutas[tipo]}?limite=100`)
export const crearActor = (tipo: TipoActor, entrada: object): Promise<{ id: string }> =>
  solicitar(`/api/v1/${rutas[tipo]}`, { method: 'POST', body: JSON.stringify(entrada) })
export const cambiarEstadoActor = (
  tipo: Exclude<TipoActor, 'COORDINADOR_ASESORES'>,
  actor: Actor,
): Promise<void> =>
  solicitar(`/api/v1/${rutas[tipo]}/${actor.id}/estado`, {
    method: 'PATCH',
    body: JSON.stringify({
      version: actor.version,
      estado: actor.estado === 'ACTIVO' ? 'INACTIVO' : 'ACTIVO',
    }),
  })

export const cambiarEstadoEstudiante = (
  usuarioId: string,
  version: number,
  estado: 'ACTIVO' | 'INACTIVO',
): Promise<void> =>
  solicitar(`/api/v1/estudiantes/${usuarioId}/estado`, {
    method: 'PATCH',
    body: JSON.stringify({ version, estado }),
  })
export const cambiarEstadoCoordinador = (actor: Actor): Promise<void> =>
  solicitar(`/api/v1/usuarios/${actor.id}/estado`, {
    method: 'PATCH',
    body: JSON.stringify({ estado: actor.estado === 'ACTIVO' ? 'INACTIVO' : 'ACTIVO' }),
  })
export const reasignar = (
  tipo: 'asesor' | 'titular',
  estudiante: Actor,
  usuarioId: string,
  motivo: string,
): Promise<void> =>
  solicitar(`/api/v1/estudiantes/${estudiante.estudianteId}/reasignar-${tipo}`, {
    method: 'POST',
    body: JSON.stringify({
      usuarioId,
      version:
        tipo === 'asesor'
          ? estudiante.asesorAsignacionVersion
          : estudiante.titularAsignacionVersion,
      motivo,
    }),
  })
